module.exports = __webpack_public_path__ + "static/media/twitter.8162db6c.svg";